import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...this.props}><path d="M0 1h11v11" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/active-link.inline.svg